module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07522_banner_800x600.c7fd0c6c.png";